@if(submissions.length)
{
<div class="mt-5">
  <div class="font-bold g-c-primaryDarkerColor">
    {{'submission_results' | translate}}
  </div>
  <div class="mt-5">
    <div class="flex align-items-center gap-2 mt-2">
      <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6 0.799805C5.36348 0.799805 4.75303 1.05266 4.30294 1.50275C3.85286 1.95284 3.6 2.56328 3.6 3.1998V10.3998H0L4.8 15.1998L9.6 10.3998H6V3.1998H14.4L16.8 0.799805H6ZM18 5.5998H14.4L19.2 0.799805L24 5.5998H20.4V12.7998C20.4 13.4363 20.1471 14.0468 19.6971 14.4969C19.247 14.9469 18.6365 15.1998 18 15.1998H7.2L9.6 12.7998H18V5.5998Z"
          fill="#241C0B" />
      </svg>
      <div class="font-bold">
        {{'number_of_submissions' | translate}}
        : {{no_submits}}
      </div>

    </div>
    <div class="flex align-items-center gap-2 mt-2">
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11 0.5C5.15 0.5 0.5 5.15 0.5 11C0.5 16.85 5.15 21.5 11 21.5C16.85 21.5 21.5 16.85 21.5 11C21.5 5.15 16.85 0.5 11 0.5ZM15.05 16.25L11 12.2L6.95 16.25L5.75 15.05L9.8 11L5.75 6.95L6.95 5.75L11 9.8L15.05 5.75L16.25 6.95L12.2 11L16.25 15.05L15.05 16.25Z"
          fill="#EA4F49" />
      </svg>

      <div class="font-bold">
        {{'number_of_rejections' | translate}}
        : {{no_rejections}}
      </div>

    </div>
  </div>
  <div class="font-bold  mt-5 g-c-primaryDarkerColor">
    {{'select_evaluation_result' | translate }}
  </div>
  <div class="flex align-items-center mt-3">
    <p-dropdown (onChange)="versionChange()" [(ngModel)]="selectedSubmissionId" [options]="options"
      placeholder="اختر نتيجة تقييم الطلب" optionLabel="name" optionValue="value" />
  </div>

  <div class="flex align-items-center  gap-2 mt-5">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.5 5C3.10218 5 2.72064 4.84196 2.43934 4.56066C2.15804 4.27936 2 3.89782 2 3.5C2 3.10218 2.15804 2.72064 2.43934 2.43934C2.72064 2.15804 3.10218 2 3.5 2C3.89782 2 4.27936 2.15804 4.56066 2.43934C4.84196 2.72064 5 3.10218 5 3.5C5 3.89782 4.84196 4.27936 4.56066 4.56066C4.27936 4.84196 3.89782 5 3.5 5ZM19.41 9.58L10.41 0.58C10.05 0.22 9.55 0 9 0H2C0.89 0 0 0.89 0 2V9C0 9.55 0.22 10.05 0.59 10.41L9.58 19.41C9.95 19.77 10.45 20 11 20C11.55 20 12.05 19.77 12.41 19.41L19.41 12.41C19.78 12.05 20 11.55 20 11C20 10.44 19.77 9.94 19.41 9.58Z"
        fill="#241C0B" />
    </svg>
    <div class="font-bold">
      {{'rating_status' | translate}}
    </div>

    @if(selectedSubmisson?.status=='rejected')
    {
    <p-tag severity="danger" value="{{'rejected' | translate }}" />
    }@else if(selectedSubmisson?.status=='pending')
    {
      @if(selectedSubmisson?.isApprovedByDepartmentManager === null || selectedSubmisson?.isApprovedByDepartmentManager === false)
      {
        <p-tag severity="warning" value="{{'pending_department_approval' | translate}}" />
      }
      @else if(selectedSubmisson?.isApprovedByDepartmentManager === true && (selectedSubmisson?.isApprovedByStrategyManager === null || selectedSubmisson?.isApprovedByStrategyManager === false))
      {
        <p-tag severity="info" value="{{'approved_by_department_pending_strategy' | translate}}" />
      }
      @else
      {
        <p-tag severity="warning" value="{{'under_review' | translate}}" />
      }
    }
    @else if(selectedSubmisson?.status=='approved')
    {
    <p-tag severity="success" value="{{'approved' | translate}}" />
    }

  </div>
  
  <!-- Approval Details Section -->
  @if(selectedSubmisson?.status=='pending' || selectedSubmisson?.status=='approved')
  {
  <div class="approval-details mt-4 p-3 border-round-md" style="background-color: #f8f9fa;">
    <div class="font-bold mb-3 g-c-primaryDarkerColor">
      {{'approval_workflow' | translate}}
    </div>
    
    <!-- Department Admin Approval -->
    <div class="flex align-items-center gap-2 mb-2">
      <i class="fa-solid fa-building"></i>
      <span class="font-semibold">{{'department_manager_approval' | translate}}:</span>
      @if(selectedSubmisson?.isApprovedByDepartmentManager === true) {
        <p-tag severity="success" value="{{'approved' | translate}}" />
        @if(selectedSubmisson?.departmentManagerApprovalDate) {
          <span class="text-sm text-500">{{selectedSubmisson.departmentManagerApprovalDate | date:'dd/MM/yyyy HH:mm'}}</span>
        }
      } @else if(selectedSubmisson?.isApprovedByDepartmentManager === false) {
        <p-tag severity="danger" value="{{'rejected' | translate}}" />
      } @else {
        <p-tag severity="warning" value="{{'pending' | translate}}" />
      }
    </div>
    
    <!-- Strategy Admin Approval -->
    <div class="flex align-items-center gap-2">
      <i class="fa-solid fa-chess-knight"></i>
      <span class="font-semibold">{{'strategy_manager_approval' | translate}}:</span>
      @if(selectedSubmisson?.isApprovedByStrategyManager === true) {
        <p-tag severity="success" value="{{'approved' | translate}}" />
        @if(selectedSubmisson?.strategyManagerApprovalDate) {
          <span class="text-sm text-500">{{selectedSubmisson.strategyManagerApprovalDate | date:'dd/MM/yyyy HH:mm'}}</span>
        }
      } @else if(selectedSubmisson?.isApprovedByStrategyManager === false) {
        <p-tag severity="danger" value="{{'rejected' | translate}}" />
      } @else {
        <p-tag severity="warning" value="{{'pending' | translate}}" />
      }
    </div>
  </div>
  }
  <div class="flex align-items-center gap-2 mt-2">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 18L18 6" stroke="#241C0B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M17 19C18.1046 19 19 18.1046 19 17C19 15.8954 18.1046 15 17 15C15.8954 15 15 15.8954 15 17C15 18.1046 15.8954 19 17 19Z"
        fill="#241C0B" stroke="#241C0B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9Z"
        fill="#241C0B" stroke="#241C0B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <div class="font-bold">
      {{'rating_score' | translate}}
      :
      @if(selectedSubmisson?.status=='pending'){
      <p-tag severity="warning" value="{{'n_a' | translate}}" />
      }
      @else{
      {{selectedSubmisson?.score}}
      }
    </div>

  </div>
  @if(selectedSubmisson?.status!="pending")
  {
  <div class="mt-5">

    <p-table [class]="dir" [dir]="dir" [value]="selectedSubmisson?.criterias" [tableStyle]="{ 'min-width': '50rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th>
            {{'criteria' | translate }}
          </th>
          <th>
            {{'score' | translate }}
          </th>

          <th [pSortableColumn]="'score'">
            {{'value' | translate}}
          </th>
          <th>
            {{'notes' | translate}}
          </th>

          <th>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-submission>
        <tr>
          <td>
            @if(dir=="rtl"){
            {{submission.name_ar}}
            }@else{
            {{submission.name_en}}
            }
          </td>
          <td>
            {{submission?.maxScore}}
          </td>
          <td>
            {{submission?.score}}
          </td>
          <td>
            {{submission?.notes}}
          </td>

          <td>

          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr>
          <td class="text-right" colspan="">{{'total_score'|translate}}</td>
          <td class="text-right">100</td>
          <td class="text-center">
            <div class="flex justify-content-center align-items-center">
              <div class="border-1 text-center w-fit  border-round-md  text-center border-primary p-2">
                {{selectedSubmisson?.score}}
              </div>
            </div>
          </td>
          <td>
          </td>
          <td>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <textarea pInputTextarea class="mt-4" [value]="selectedSubmisson?.reasons" readonly rows="3"
      name="reasons"></textarea>

  </div>

  }
</div>

}@else{
<div class="text-center font-bold text-xl  mt-5">
  <i class="fa-solid fa-circle-exclamation"></i>
  {{'please_submit_request_first' | translate}}
</div>
}